import { Component, Input } from '@angular/core';
import { FiltersChannel } from '../../../../../filters/models/filters-channel.model';
import { Filters } from '../../../../../filters/models/filters.model';
import { IStatsTileDefinition } from '../../../../interfaces/tiles/definitions/stats-tile-definition.interface';

@Component({
  standalone: false,
  selector: 'suvo-bi-stats-tile',
  template: `
    <mat-card>
      <mat-card-header *ngIf="tileInstance?.title" style="padding: 16px">
        <mat-card-title>{{ tileInstance.title }}</mat-card-title>
      </mat-card-header>
      <mat-card-content [ngStyle]="statsContainerStyles">
        <div *ngFor="let statDefinition of tileInstance.statDefinitions" [ngStyle]="statsItemStyles">
          <suvo-bi-stat [statDefinition]="statDefinition"></suvo-bi-stat>
        </div>
      </mat-card-content>
    </mat-card>
  `,
})
export class StatsTileComponent {
  @Input() tileInstance: IStatsTileDefinition;
  @Input() filtersChannel: FiltersChannel;

  filters: Filters;

  get statsContainerStyles(): Record<string, string> {
    const layout = this.tileInstance?.layout;
    if (layout?.mode !== 'grid') {
      return {
        display: 'flex',
      };
    }

    const columns = layout.columns && layout.columns > 0 ? layout.columns : 2;
    const gap = layout.gap ?? 16;
    const normalizedGap = typeof gap === 'number' ? `${gap}px` : gap;

    return {
      display: 'grid',
      'grid-template-columns': `repeat(${columns}, minmax(0, 1fr))`,
      gap: normalizedGap,
    };
  }

  get statsItemStyles(): Record<string, string> {
    if (this.tileInstance?.layout?.mode === 'grid') {
      return {
        'min-width': '0',
      };
    }

    return {
      flex: '1',
    };
  }
}
